
import { Component, Vue, Watch } from 'vue-property-decorator';
import BasePagina from '@/components/base/BasePagina.vue';
import BaseDialog from '@/components/base/BaseDialog.vue';
import BasePesquisa from '@/components/base/BasePesquisa.vue';
import BaseLista from '@/components/base/BaseLista.vue';
import BaseCampos from '@/components/base/BaseCampos.vue';
import DatePicker from '@/components/base/DatePicker.vue';
import TimePicker from '@/components/base/TimePicker.vue';
// Services
import CupomService from '@/services/cupom.service';
// Models
import { CupomInterface } from '@/shared/models/cupom/cupom.interface';
import { CupomFilter } from '@/shared/models/cupom/cupom.filter';
import { BaseDialogInterface } from '@/shared/models/base/dialog.interface';
// UTILS
import Rules from '@/shared/utils/rules.util';

@Component({
  components: {
    BasePagina,
    BaseDialog,
    BasePesquisa,
    BaseLista,
    BaseCampos,
    DatePicker,
    TimePicker,
  },
})
export default class Cupom extends Vue {
  private rules = Rules;

  public labelBotaoNovo = 'Novo Cupom';

  public editedItem = {} as CupomInterface;

  public filtro = {} as CupomFilter;

  // Dialog
  public dialogInterface = {
    formTitle: '',
    dialog: false,
    textBotaoPrimario: 'Salvar',
    funcaoPrimaria() {
      //
    },
    fecharModal: this.fecharModalCriarEditar,
    colorBotaoPrimario: 'primary',
  } as BaseDialogInterface;

  // Campos do Dialog
  public readonlyCamposDialog = false;

  // Lista do data-table
  public lista: Array<CupomInterface> = [];

  // DateTime
  public dateTimeInicia: Record<string, any> = { date: '', time: '' };

  public dateTimeExpira: Record<string, any> = { date: '', time: '' };

  public headers: Array<Record<string, any>> = [
    {
      text: 'Bônus', align: 'center', sortable: false, value: 'bonus',
    },
    {
      text: 'Código', align: 'center', sortable: false, value: 'codigo',
    },
    {
      text: 'Descrição', align: 'center', sortable: false, value: 'descricao',
    },
    {
      text: 'Inicia em', align: 'center', sortable: false, value: 'iniciaEm',
    },
    {
      text: 'Expira em', align: 'center', sortable: false, value: 'expiraEm',
    },
    {
      text: 'Ação', align: 'center', sortable: false, value: 'acao',
    },
  ];

  public colapses = [
    { titulo: 'Filtragem', nomeSlot: 'pesquisa' },
    { titulo: 'Lista de Cupons', nomeSlot: 'lista' },
  ];

  public listaCamposPesquisa = [
    {
      text: 'Bônus', type: 'textField', value: 'bonus', cols: '6',
    },
    {
      text: 'Código', type: 'textField', value: 'codigo', cols: '6',
    },
    {
      text: 'Descrição', type: 'textField', value: 'descricao', cols: '12',
    },
  ];

  public listaCamposCriarEditar = [
    {
      text: 'Bônus', type: 'numberField', value: 'bonus', cols: '6', counter: '10', maxlength: '10', required: true, rules: [this.rules.campo_obrigatorio, this.rules.somente_numeros_positivos],
    },
    {
      text: 'Quantidade', type: 'numberField', value: 'quantidade', cols: '6', counter: '8', maxlength: '8', required: true, rules: [this.rules.campo_obrigatorio, this.rules.somente_numeros_positivos],
    },
    {
      text: 'Código', type: 'textField', value: 'codigo', cols: '12', counter: '100', maxlength: '100', required: true, rules: [this.rules.campo_obrigatorio],
    },
    {
      text: 'Descrição', type: 'textField', value: 'descricao', cols: '12', counter: '255', maxlength: '255', required: true, rules: [this.rules.campo_obrigatorio],
    },
  ];

  public listaAcoes = [
    { tooltip: 'Editar', icon: 'mdi-square-edit-outline', function: this.abrirEditar },
    { tooltip: 'Excluir', icon: 'mdi-delete-outline', function: this.abrirExcluir },
  ];

  public listaValues = [
    { value: 'iniciaEm', function: this.mascararIniciaEm },
    { value: 'expiraEm', function: this.mascararExpiraEm },
  ];

  // Pesquisar
  async pesquisar(filtro: CupomFilter) {
    this.lista = await new CupomService().buscarPorFiltro(filtro);
  }

  async buscarTodos() {
    this.lista = await new CupomService().buscarTodos();
  }

  // Dialog de Editar
  private async abrirEditar(item: any) {
    this.dialogInterface.formTitle = 'Editar Cupom';
    this.dialogInterface.textBotaoPrimario = 'Salvar';
    this.dialogInterface.colorBotaoPrimario = 'primary';
    this.readonlyCamposDialog = false;
    this.dialogInterface.funcaoPrimaria = this.salvarAtualizar;
    this.editedItem = await new CupomService().buscarPorId(item.id);
    if (this.editedItem !== undefined) {
      this.dateTimeInicia = this.formataDateTimeEditar(this.editedItem.iniciaEm);
      this.dateTimeExpira = this.formataDateTimeEditar(this.editedItem.expiraEm);
      this.dialogInterface.dialog = true;
    }
  }

  // Dialog de Criar
  private abrirCriar() {
    this.dialogInterface.formTitle = 'Novo Cupom';
    this.dialogInterface.textBotaoPrimario = 'Salvar';
    this.readonlyCamposDialog = false;
    this.dialogInterface.colorBotaoPrimario = 'primary';
    this.dialogInterface.funcaoPrimaria = this.salvarAtualizar;
    this.editedItem = {} as CupomInterface;
    this.dialogInterface.dialog = true;
  }

  // Dialog de Excluir
  private async abrirExcluir(item: any) {
    this.dialogInterface.formTitle = 'Excluir Cupom';
    this.dialogInterface.textBotaoPrimario = 'Excluir';
    this.readonlyCamposDialog = true;
    this.dialogInterface.colorBotaoPrimario = 'warning';
    this.dialogInterface.funcaoPrimaria = this.excluir;
    this.editedItem = await new CupomService().buscarPorId(item.id);
    if (this.editedItem !== undefined) {
      this.dateTimeInicia = this.formataDateTimeEditar(this.editedItem.iniciaEm);
      this.dateTimeExpira = this.formataDateTimeEditar(this.editedItem.expiraEm);
      this.dialogInterface.dialog = true;
    }
  }

  async salvarAtualizar() {
    this.editedItem.iniciaEm = this.formataDateTimeCadastrar(this.dateTimeInicia);
    this.editedItem.expiraEm = this.formataDateTimeCadastrar(this.dateTimeExpira);
    new CupomService().salvarAtualizar(this.editedItem)
      .then(() => {
        this.fecharModalCriarEditar();
        this.pesquisar(this.filtro);
      });
  }

  async excluir() {
    new CupomService().excluir(this.editedItem)
      .then(() => {
        this.fecharModalCriarEditar();
        this.pesquisar(this.filtro);
      });
  }

  private formataDateTimeCadastrar(dateTime: Record<string, any>) {
    const [year, month, day] = (dateTime as any).date.split('-');
    return `${day}-${month}-${year} ${(dateTime as any).time.toString()}:00`;
  }

  private formataDateTimeEditar(dateTime: string) {
    const [day, month, year] = dateTime.substring(0, 10).split('-');
    return {
      date: `${year}-${month}-${day}`,
      time: `${dateTime.substring(11, 16).toString()}`,
    };
  }

  private mascararIniciaEm(cupom: CupomInterface) {
    return this.mascararDateTime(cupom.iniciaEm);
  }

  private mascararExpiraEm(cupom: CupomInterface) {
    return this.mascararDateTime(cupom.expiraEm);
  }

  private mascararDateTime(dateTime: string) {
    const [day, month, year] = dateTime.substring(0, 10).split('-');
    return `${day}/${month}/${year} ${dateTime.substring(11, 16)}`;
  }

  private fecharModalCriarEditar() {
    this.dialogInterface.dialog = false;
    this.editedItem = {} as CupomInterface;
  }

  mounted() {
    this.buscarTodos();
  }
}
